import React, { useState } from "react";
import { startRegistration } from "@simplewebauthn/browser";
import { useSecureContext } from "../../../hooks/secure-http-context";
import { PasskeysLoginButtonComponent } from "../shared/PasskeysLoginButtonComponent";
const SetPasskeysComponent = ({
  didSetPasskeys,
  resetToken
}) => {
  const {
    authService
  } = useSecureContext();
  const [loading, setLoading] = useState(false);
  const registerPasskeys = async () => {
    try {
      setLoading(true);
      const regOptions = await authService.passkeysRegistrationOptions(resetToken);
      if (regOptions) {
        const registrationResponse = await startRegistration(regOptions);
        const verifyResponse = await authService.passkeysRegister(registrationResponse, resetToken);
        if (verifyResponse?.verified) {
          didSetPasskeys();
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PasskeysLoginButtonComponent, {
    mode: "create",
    onClick: () => registerPasskeys(),
    loading: loading
  }));
};
export { SetPasskeysComponent };